<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="Open"
      :width="width ? width : '60%'"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="configForm"
        label-width="120px"
        :model="formModel"
        :rules="labelRules"
      >
        <el-row :gutter="16">
          <el-col
            v-for="(item, index) in config"
            :key="index"
            :span="item.span ? item.span : 8"
          >
            <el-form-item :label="item.label" :prop="item.prop">
              <!--输入框表单类型-->
              <el-input
                v-if="item.type === 'text'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :show-word-limit="item.showWordLimit"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @input.native="
                  item.oninput
                    ? (formData[item.prop] = item.oninput($event.target.value))
                    : null
                "
              >
                <template v-if="item.rightText" slot="append">
                  {{ item.rightText }}
                </template>
              </el-input>
              <el-input
                v-if="item.type === 'textAznum'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @input.native="formData[item.prop] = checkInputEnglish($event)"
              />
              <el-input
                v-if="item.type === 'textAz'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @input.native="formData[item.prop] = checkInputEnglishB($event)"
              />
              <el-input
                v-if="item.type === 'textCN'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                show-word-limit
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @input.native="formData[item.prop] = checkInputCN($event)"
              />
              <el-input
                v-if="item.type === 'textNum'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                show-word-limit
                @input.native="formData[item.prop] = checkInputNum($event)"
              >
                <template v-if="item.rightText" slot="append">
                  {{ item.rightText }}
                </template>
              </el-input>
              <el-input
                v-if="item.type === 'textNum.'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                @input.native="
                  formData[item.prop] = checkInputPrice(
                    $event,
                    item.num ? item.num : 3
                  )
                "
              >
                <template v-if="item.rightText" slot="append">
                  {{ item.rightText }}
                </template>
              </el-input>

              <!--文本域表单类型-->
              <el-input
                v-if="item.type === 'textarea'"
                v-model="formData[item.prop]"
                :maxlength="item.maxlength"
                :disabled="item.disabled"
                :placeholder="item.placeholder ? item.placeholder : '请输入'"
                rows="4"
                show-word-limit
                type="textarea"
              />

              <el-switch
                v-if="item.type === 'switch'"
                v-model="formData[item.prop]"
                :active-value="1"
                :inactive-value="0"
              />
              <div
                class="text-muted f12"
                v-if="item.type === 'switch' && item.text"
              >
                {{ item.text }}
              </div>
              <el-cascader
                v-if="item.type === 'city'"
                v-model="formData[item.prop]"
                size="small"
                style="width: 100%"
                :show-all-levels="item.showAllLevels"
                :props="{
                  checkStrictly: item.props.checkStrictly,
                  multiple: item.props.multiple,
                  value: item.props.value ? item.props.value : 'ID',
                  children: item.props.children
                    ? item.props.children
                    : 'children',
                  label: item.props.label ? item.props.label : 'label',
                }"
                :options="item.options"
                placeholder="全部"
                clearable
              />
              <!--checkbox表单类型-->
              <el-checkbox-group
                v-if="item.type === 'checkbox'"
                v-model="formData[item.prop]"
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
              >
                <el-checkbox
                  v-for="option in item.data"
                  :key="option.id"
                  :label="option.id"
                >
                  {{ option.name }}
                </el-checkbox>
              </el-checkbox-group>
              <!--radio表单类型-->
              <el-radio-group
                v-if="item.type === 'radio'"
                v-model="formData[item.prop]"
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
              >
                <el-radio
                  v-for="option in item.data"
                  :key="option.id"
                  :label="option.id"
                >
                  {{ option.name }}
                </el-radio>
              </el-radio-group>
              <!--下拉选择类型-->
              <el-select
                v-if="item.type === 'select'"
                v-model="formData[item.prop]"
                clearable
                filterable
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
              >
                <el-option
                  v-for="option in item.data"
                  :key="
                    item.optionConfig
                      ? option[`${item.optionConfig.id}`]
                      : option.id
                  "
                  :label="
                    item.optionConfig
                      ? option[`${item.optionConfig.label}`]
                      : option.label
                  "
                  :value="
                    item.optionConfig
                      ? option[`${item.optionConfig.id}`]
                      : option.id
                  "
                  :disabled="option.disabled"
                />
              </el-select>
              <el-select
                v-if="item.type === 'dict'"
                v-model="formData[item.prop]"
                filterable
                clearable
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
              >
                <el-option
                  v-for="(selectOption, i) in dictData[item.dictKey]"
                  :key="i"
                  :label="selectOption.desc"
                  :value="selectOption.code"
                />
              </el-select>
              <el-select
                v-if="item.type === 'dictLog'"
                v-model="formData[item.prop]"
                filterable
                clearable
                :placeholder="item.placeholder ? item.placeholder : '请选择'"
              >
                <el-option
                  v-for="(selectOption, i) in dictData[item.dictKey]"
                  :key="i"
                  :label="selectOption.desc"
                  :value="selectOption.code"
                />
              </el-select>
              <el-date-picker
                v-if="item.type === 'datepicker'"
                v-model="formData[item.prop]"
                :placeholder="
                  item.placeholder ? item.placeholder : '请选择日期'
                "
                type="date"
              />
              <div v-if="item.tipText" class="tip-text-color">
                {{ item.tipText }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          v-if="formData && formData.assetType && formData.assetType == 4"
          :loading="btnLoading"
          type="primary"
          @click="submitForm"
        >
          确定并生成请款OA
        </el-button>
        <el-button
          v-else
          :loading="btnLoading"
          type="primary"
          @click="submitForm"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'BaseDialogForm',
    props: ['title', 'width', 'formData', 'config', 'labelRules', 'dictKey'],
    data() {
      return {
        formModel: {},
        dialogTitle: '',
        btnLoading: false,
        Open: true,
        dictData: [],
      }
    },
    watch: {
      /*实现表单数据的绑定，实时接收父组件的数据变化*/
      formData() {
        // this.Open = true
        this.formModel = this.formData
      },
    },
    mounted() {
      if (this.dictKey) {
        this.getDict()
      }
      // 将组件上的属性赋值给当前组件内变量，因为props只能单向绑定,还需要监听属性值变化进行父子组件间交互
      this.formModel = this.formData
      this.dialogTitle = this.title
    },
    methods: {
      getDict() {
        this.getDictData(this.dictKey).then((res) => {
          this.dictData = res.data
        })
      },
      // 优化：dictLog 选择时返回整个对象（优先匹配 code，其次 id/value）
      checkInputPrice2(event, small, type) {
        let that = event.target
        that.value = that.value.replace(/。/g, '.') // 中文句号换成英文点
        if (type == '>zero') {
          that.value = that.value.replace(/^0*/g, '') // 第一个数不能为0 ，若为0替换为空
        }

        that.value = that.value.replace(/[^\d.]/g, '') // 是否是数字 和小数点，若是除数字 和小数点之外的则替换为空
        that.value = that.value.replace(/^\./g, '') // 确证第一个为数字而不是“.”
        that.value = that.value.replace(/\.{2,}/g, '.') // 只能输入一个“.”
        that.value = that.value
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.') // 保证“.”只出现一次，而不能出现两次以上
        if (small == 3) {
          that.value = that.value.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3') // 只能输入两个小数
        }
        // if (small == 1) {
        //   that.value = that.value.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3"); // 只能输入1个小数
        // }
        return that.value
      },
      // 提交表单数据
      submitForm() {
        this.$refs.configForm.validate((valid) => {
          if (valid) {
            // 让父组件接收到响应数据
            this.btnLoading = true
            setTimeout(() => {
              this.btnLoading = false
            }, 1000)
            this.$emit('submitForm', this.formModel)
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleClose() {
        this.Open = false
        this.$emit('handleClose')
      },
      // 重置表单状态
      resetForm() {
        if (this.$refs.configForm) {
          this.$refs.configForm.resetFields()
        }
      },
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .tip-text-color {
    color: #999999;
  }
  .el-input {
    width: 100% !important;
  }

  .el-select {
    width: 100% !important;
  }
</style>
